import { useLocalStore } from 'mobx-react';
import { useContext } from 'react';
import { AppService } from '@ibe/services';
import { AppContext } from './Contexts';

function useAppService(): AppService {
  const context = useContext(AppContext);
  return useLocalStore<AppService>(() => context);
}

export default useAppService;
